import React from 'react'
import { SearchIcon } from '@heroicons/react/solid'
import { useEffect } from 'react';

export default function MembersHeader({search, setSearch}) {

  useEffect(() => {
    console.log(search)
  }, [search])

  return (
    <header className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-row justify-between">
        <div>
          <h1 className="text-xl md:text-3xl md:font-bold text-white capitalize">Membership</h1>
        </div>
        <div>
          <div className="relative text-gray-400 focus-within:text-gray-600">
            <div className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
              <SearchIcon className="h-5 w-5" aria-hidden="true" />
            </div>
            <input
              id="search"
              className="block w-full bg-white py-2 pl-10 pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-white focus:border-white sm:text-sm"
              placeholder="Search"
              type="search"
              name="search"
              value={search}
              onChange={(e) => {e.preventDefault(); setSearch(e.target.value)}}
            />
          </div>
        </div>
      </div>
    </header>
  )
}
